import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { Card, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'
import { AppDispatch } from '../store'
import { fetchPlacementList } from '../store/placementsSlice'
import { RootState } from '../store/rootReducer'
import Pagination from '../components/Pagination'

const Home = (): React.ReactElement | null => {
  const { t } = useTranslation('home')
  const dispatch = useDispatch<AppDispatch>()
  const { placements, loading, error, totalPages, currentLimit, currentPage, totalCount } = useSelector(
    (state: RootState) => state.placements
  )
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10)

  useEffect(() => {
    dispatch(
      fetchPlacementList({
        page,
        limit,
        year: dayjs().format('YYYY'),
      })
    )
  }, [dispatch, page, limit])

  if (loading === 'pending') {
    // TODO: Loader...
    return null
  }

  if (error) {
    // TODO: Upp kom óvænt villa...
    return null
  }

  return (
    <Card>
      <Card.Body>
        <h4>{t('virkarSkraningar')}</h4>
        {placements == null || placements.length === 0 ? (
          <div className="pb-2 pt-2">
            <i>
              <div className="mb-1">{t('engarVirkar')}.</div>
              <Link to="/skraningar">{t('skodaAllar')}</Link>
            </i>
          </div>
        ) : (
          <div className="mt-3">
            <table className="table">
              <thead>
                <tr className="bg-gray-200 small">
                  <th>{t('nafn')}</th>
                  <th className="d-none d-sm-block">{t('kennitala')}</th>
                  <th>{t('vinnustadur')}</th>
                  <th>{t('timabil')}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {placements?.map((placement) => (
                  <tr key={placement.id}>
                    <td>{placement.person.name}</td>
                    <td>
                      <div className="d-none d-md-block">{placement.person.ssn}</div>
                    </td>

                    <td>
                      {placement.placement_group.workplace.name} - {placement.placement_group.name}
                    </td>
                    <td>
                      {placement.placement_group.period.name}
                      <div style={{ display: 'block', fontSize: '13px' }}>
                        {placement.placement_group.period_part ? (
                          <i>
                            {dayjs(placement.placement_group.period_part.date_from).format('DD.MM.YYYY')} -{' '}
                            {dayjs(placement.placement_group.period_part.date_to).format('DD.MM.YYYY')}
                          </i>
                        ) : (
                          <i>
                            {dayjs(placement.placement_group.period.date_from).format('DD.MM.YYYY')} -{' '}
                            {dayjs(placement.placement_group.period.date_to).format('DD.MM.YYYY')}
                          </i>
                        )}
                      </div>
                    </td>

                    <td>
                      <OverlayTrigger placement="top" overlay={<Tooltip id={`tooltip-view`}>{t('skoda')}</Tooltip>}>
                        <Link
                          className="btn btn-secondary float-right"
                          style={{ color: '#fff' }}
                          to={`/skraning/${placement.id}`}
                        >
                          <div className="d-inline-block">
                            <FontAwesomeIcon icon={faSearch} />
                          </div>
                        </Link>
                      </OverlayTrigger>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {totalPages > 1 && (
              <Pagination
                currentLimit={currentLimit}
                currentPage={currentPage}
                currentLength={placements.length}
                totalCount={totalCount}
                totalPages={totalPages}
                onPageChange={setPage}
                onLimitChange={setLimit}
              />
            )}
          </div>
        )}

        <div className="mt-3">
          <Link className="btn btn-primary" to="/skraumsokn">
            <FontAwesomeIcon icon={faPlusCircle} /> Skrá umsókn
          </Link>
        </div>
      </Card.Body>
    </Card>
  )
}

export default Home
